<template>
  <div style="width: 100%">
    <div class="searchcontent headersearch">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">

        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.keywords" placeholder="请输入姓名或登录名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model.trim="searchForm.keywordname" placeholder="请输入行政单位"></el-input>
        </el-form-item>
        <el-form-item>
          <!--系统设置 -->
          <el-cascader v-if="adminRegionLevelnum==0" size="small" v-model="searchForm.value" :options="options" :props="{ checkStrictly: true }" :show-all-levels="false" @active-item-change="handleItemChange" clearable placeholder="请选择区划地区" @change="handleCateChange">
          </el-cascader>
          <!-- 省 市 县 区 -->
          <el-select size="small" v-model="searchForm.cityLeve" clearable placeholder="请选择区划地区" v-if="adminRegionLevelnum>0 &&adminRegionLevelnum<5">
            <el-option v-for="item in searchForm.cityLevellist" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <!-- 村级 -->
          <el-input size="small" v-model.trim="searchForm.value1" :placeholder="villagename" v-if="adminRegionLevelnum==5" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select size="small" v-model="searchForm.isUseState" placeholder="请选择注销状态">
            <el-option v-for="item in searchForm.isUseOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
                    <el-select size="small" v-model="searchForm.regionLevel" placeholder="请选择行政级别">
                        <el-option
                        v-for="item in searchForm.regionLevellist"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item>
          <el-button size="small" plain type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        </el-form-item>
        <!--  -->
        <el-form-item>
          <el-button size="small" v-if="permission.isHaveAddPermission && adminRegionLevel == true" plain type="primary" icon="el-icon-plus" @click="onAdd">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="searchtable">
      <el-table ref="table" :data="adminlist" border stripe :row-key="getRowKey" v-loading="showDataLoading" :header-row-style="{height:'30px'}" :header-cell-style="{padding:'5px'}" :row-style="{height:'30px'}" :cell-style="{padding:'5px'}" :height="tableHeight">
        <el-table-column label="编号" width="60">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column prop="adminLoginName" label="登录名" width="165">
        </el-table-column>
        <el-table-column prop="adminName" label="姓名" width="140">
        </el-table-column>
        <el-table-column prop="adminUnitName" label="行政单位" min-width="170">
        </el-table-column>
        <el-table-column prop="roleName" label="角色" width="130">
        </el-table-column>
        <el-table-column prop="adminMobileTel" label="手机号码" width="130">
        </el-table-column>
        <el-table-column prop="adminIdcardNumber" label="身份证号" width="165">
        </el-table-column>
        <el-table-column label="注销状态" width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isUse == 0">已注销</span>
            <span v-if="scope.row.isUse == 1">未注销</span>
          </template>
        </el-table-column>
        <el-table-column prop="closeTime" label="注销日期" width="155">
        </el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <!-- -->
            <el-button style="margin-left:5px;margin-right:5px" type="text" size="mini" v-if="permission.isHaveEditPermission && adminRegionLevel == true" :disabled='scope.row.adminID==1' @click="onEditAdmin(scope.row)">编辑</el-button>
            <!--  -->
            <el-popconfirm title="您确定要初始化密码么？" iconColor="red" :disabled='scope.row.adminID==1' @confirm="initializationAdmin(scope.row)" v-if="permission.isHaveEditAdminLoginPwdPermission">
              <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini" :disabled='scope.row.adminID==1'>初始化密码</el-button>
            </el-popconfirm>
            <!-- v-if="scope.row.isClose == 1 && permission.isHaveDistriutionPermission==true" -->
            <el-popconfirm title="您确定要启用么？" v-if="scope.row.isUse == 0 && permission.isHaveChangeStatusPermission==true && adminRegionLevel == true" iconColor="red" @confirm="closeAdminStatus(scope.row,scope.$index)">
              <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini" class="tablecolumn" :disabled='scope.row.adminID==1'>启用</el-button>
            </el-popconfirm>
            <!-- v-if="scope.row.isClose == 0 && permission.isHaveDistriutionPermission==true" -->
            <el-popconfirm title="您确定要注销么？" iconColor="red" v-if="scope.row.isUse == 1 && permission.isHaveChangeStatusPermission==true  && adminRegionLevel == true" @confirm="closeAdminStatus(scope.row,scope.$index)">
              <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini" class="tablecolumn" :disabled='scope.row.adminID==1'>注销</el-button>
            </el-popconfirm>
            <!-- 2023-1-31新增撤销实名认证 -->
            <el-popconfirm title="您确定要撤销实名认证么？" iconColor="red" v-if="permission.isHaveRevokeAdminAuthPermission==true" @confirm="revokeAdminAuthHandle(scope.row)">
              <el-button style="margin-left:5px;margin-right:5px" slot="reference" type="text" size="mini" class="tablecolumn" :disabled='scope.row.adminID==1'>撤销实名认证</el-button>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>

      <div class="pageblock">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>

    </div>

    <el-dialog title="添加管理员" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :style="'margin-top:0px;left:'+initLeft()" @close="clearEditList('addForm')" :visible.sync="dialogAddAdminFormVisible">
      <el-form ref="addForm" :key="addKey" :rules="addRules" label-width="120px" :model="addForm">
        <el-form-item label="登录名" class="is-required" prop="adminLoginName">
          <el-input size="medium" v-model.trim="addForm.adminLoginName" prefix-icon="el-icon-user" placeholder="请输入登录名"></el-input>
        </el-form-item>
        <el-form-item label="初始密码" class="is-required">
          <el-input size="medium" disabled="disabled" v-model.trim="addForm.adminLoginPwd" prefix-icon="el-icon-key" placeholder="请输入初始密码"></el-input>
        </el-form-item>
        <el-form-item label="行政级别" class="is-required">
          <el-select v-model="addForm.regionLevel" size="medium" placeholder="请选择行政级别" @change="selectChange">
            <el-option v-for="item in addForm.allregionLevel" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="addForm.provinceID" size="medium" disabled="disabled" style="margin-left:30px" placeholder="请选择省级行政区划" v-if="addForm.regionLevel == 1 ||addForm.regionLevel == 2 || addForm.regionLevel == 3||addForm.regionLevel == 4" @change="searchFormchange(2,addForm.provinceID)">
            <el-option v-for="item in provinceList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.cityID" size="medium" style="margin-left:30px" placeholder="请选择市级行政区划" v-if="addForm.regionLevel == 2 || addForm.regionLevel == 3||addForm.regionLevel == 4||addForm.regionLevel == 5" @change="searchFormchange(3,addForm.cityID)">
            <el-option v-for="item in cityList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.districtID" size="medium" style="margin-left:30px" placeholder="请选择县级行政区划" v-if="addForm.regionLevel == 3||addForm.regionLevel == 4||addForm.regionLevel == 5" @change="searchFormchange(4,addForm.districtID)">
            <el-option v-for="item in districtList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.countryID" size="medium" style="margin-left:30px" placeholder="请选择乡级行政区划" v-if="addForm.regionLevel == 4||addForm.regionLevel == 5" @change="searchFormchange(5,addForm.countryID)">
            <el-option v-for="item in countryList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>

          <el-select v-model="addForm.villageID" size="medium" style="margin-left:30px" placeholder="请选择村级行政区划" v-if="addForm.regionLevel == 5">
            <el-option v-for="item in villageList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="行政单位" class="is-required" prop="adminunitname">
          <el-input size="medium" v-model.trim="addForm.adminunitname" placeholder="请输入行政单位"></el-input>
        </el-form-item>
        <el-form-item label="所属角色" class="is-required">
          <el-select v-model="addForm.roleID" size="medium" placeholder="请选择角色">
            <el-option v-for="item in addForm.rolelist" :key="item.roleID" :label="item.roleName" :value="item.roleID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-switch-button" @click="dialogAddAdminFormVisible = false">取 消</el-button>
        <el-button size="medium" icon="el-icon-document-checked" type="primary" :loading="addbuttonloading" :disabled="addbuttondisabled" @click="onAddSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改管理员" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :style="'margin-top:0px;left:'+initLeft()" :visible.sync="dialogEditAdminFormVisible">
      <el-form ref="editForm" :key="editKey" :rules="editRules" label-width="120px" :model="editForm">
        <el-form-item label="管理员名称" prop="adminName">
          <el-input size="medium" v-model.trim="editForm.adminName" prefix-icon="el-icon-user" placeholder="请输入管理员名称"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="adminMobileTel">
          <el-input size="medium" maxlength="11" v-model.trim="editForm.adminMobileTel" prefix-icon="el-icon-user" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="adminIdcardNumber" class="is-required">
          <el-input size="medium" v-model.trim="editForm.adminIdcardNumber" prefix-icon="el-icon-message" placeholder="请输入身份证号" maxlength="18" onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')"></el-input>
        </el-form-item>

        <el-form-item label="行政级别：" size="medium" class="is-required">
          <el-select v-model="addForm.regionLevel" size="medium" placeholder="请选择行政级别" @change="selectChange">
            <el-option v-for="item in addForm.allregionLevel" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="addForm.provinceID" size="medium" disabled="disabled" style="margin-left:30px" placeholder="请选择省级行政区划" v-if="addForm.regionLevel == 1 ||addForm.regionLevel == 2 || addForm.regionLevel == 3||addForm.regionLevel == 4||addForm.regionLevel == 5" @click.native="clickFormchange(1,0)" @change="editFormchange(2,addForm.provinceID)">
            <el-option v-for="item in provinceList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.cityID" size="medium" style="margin-left:30px" placeholder="请选择市级行政区划" v-if="addForm.regionLevel == 2 || addForm.regionLevel == 3||addForm.regionLevel == 4||addForm.regionLevel == 5" @click.native="clickFormchange(2,addForm.provinceID)" @change="editFormchange(3,addForm.cityID)">
            <el-option v-for="item in cityList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.districtID" size="medium" style="margin-left:30px" placeholder="请选择县级行政区划" v-if="addForm.regionLevel == 3||addForm.regionLevel == 4||addForm.regionLevel == 5" @click.native="clickFormchange(3,addForm.cityID)" @change="editFormchange(4,addForm.districtID)">
            <el-option v-for="item in districtList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.countryID" size="medium" style="margin-left:30px" placeholder="请选择乡级行政区划" v-if="addForm.regionLevel == 4||addForm.regionLevel == 5" @click.native="clickFormchange(4,addForm.districtID)" @change="editFormchange(5,addForm.countryID)">
            <el-option v-for="item in countryList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
          <el-select v-model="addForm.villageID" size="medium" style="margin-left:30px" placeholder="请选择村级行政区划" v-if="addForm.regionLevel == 5" @click.native="clickFormchange(5,addForm.countryID)">
            <el-option v-for="item in villageList" :key="item.baseRegionID" :label="item.baseRegionName" :value="item.baseRegionID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行政单位" class="is-required" prop="adminunitname">
          <el-input size="medium" v-model.trim="editForm.adminunitname" placeholder="请输入行政单位"></el-input>
        </el-form-item>
        <el-form-item label="所属角色" class="is-required">
          <el-select v-model="editForm.roleID" size="medium" placeholder="请选择角色">
            <el-option v-for="item in editForm.rolelist" :key="item.roleID" :label="item.roleName" :value="item.roleID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-switch-button" @click="dialogEditAdminFormVisible = false">取 消</el-button>
        <el-button size="medium" icon="el-icon-document-checked" type="primary" :loading="editbuttonloading" :disabled="editbuttonloading" @click="onEditSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改密码" :show-close="true" :close-on-click-modal="false" custom-class="dialog_wrap" :style="'margin-top:0px;left:'+initLeft()" :visible.sync="dialogEditAdminPwdFormVisible">
      <el-form ref="editPwdForm" :key="editPwdKey" :rules="editPwdRules" label-width="120px" :model="editPwdForm">
        <el-form-item label="登录密码" prop="adminLoginPwd" class="is-required">
          <el-input size="medium" v-model="editPwdForm.adminLoginPwd" prefix-icon="el-icon-key" show-password placeholder="请输入登录密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码" prop="adminLoginRepeatPwd" class="is-required">
          <el-input size="medium" v-model="editPwdForm.adminLoginRepeatPwd" prefix-icon="el-icon-key" show-password placeholder="请重复登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" icon="el-icon-switch-button" @click="dialogEditAdminPwdFormVisible = false">取 消</el-button>
        <el-button size="medium" icon="el-icon-document-checked" type="primary" :loading="editPwdButtonLoading" :disabled="editPwdButtonLoading" @click="onEditPwdSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { adminModule, roleModule } from '@/request/admin.js'
import { regionModule } from '@/request/systemmange.js'
import { publicFun } from '@/tools/time.js'
import router from '@/router.js'
import store from '@/store'
import { baseconfig } from '@/config.js'
import { permissionTool } from '@/tools/permissiontool.js'
import elDragDialog from '@/directive/el-drag-dialog'
import $ from 'jquery'

import { parentregioninfoModule } from '@/request/systemmange.js'
import { sysframe } from '@/tools/sysframe.js'
export default {
  directives: { elDragDialog },
  data() {
    var validatecard = (rule, code, callback) => {
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 ',
      }
      var tip = ''
      var pass = true
      if (
        !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          code
        )
      ) {
        tip = '身份证号格式错误'
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        // tip = "地址编码错误"
        tip = '身份证输入错误'
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          var last = parity[sum % 11]
          if (parity[sum % 11] != code[17]) {
            // tip = "校验位错误"
            tip = '身份证输入错误'
            pass = false
          }
        }
      }
      if (!pass) {
        callback(new Error(tip))
      } else {
        callback()
      }
    }
    var validatetel = (rule, value, callback) => {
      if (value != '') {
        // var regex = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,16}$/
        var regex = /^1[3456789]\d{9}$/
        if (regex.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var validateCallAdminLoginName = (rule, value, callback) => {
      if (this.addErrors.adminLoginName) {
        callback(new Error(this.addErrors.adminLoginName))
      } else {
        callback()
      }
    }
    var validateCallEditAdminName = (rule, value, callback) => {
      if (this.editErrors.adminName) {
        callback(new Error(this.editErrors.adminName))
      } else {
        callback()
      }
    }
    var validateEditPwdPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        var regex = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,20}$/
        if (regex.test(value)) {
          callback()
        } else {
          callback(new Error('请输入8到20位的数字字母混合密码'))
        }
      }
    }
    var validateCallEditPwdLoginPassword = (rule, value, callback) => {
      if (this.editPwdErrors.adminLoginPwd) {
        callback(new Error(this.editPwdErrors.adminLoginPwd))
      } else {
        callback()
      }
    }
    var validateEditPwdRepeatPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else {
        var regex = /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{8,20}$/
        if (regex.test(value)) {
          if (value === this.editPwdForm.adminLoginPwd) {
            callback()
          } else {
            callback(new Error('两次密码不一致'))
          }
        } else {
          callback(new Error('请输入8到20位的数字字母混合密码'))
        }
      }
    }
    var validateCallEditPwdLoginRepeatPassword = (rule, value, callback) => {
      if (this.editPwdErrors.adminLoginRepeatPwd) {
        callback(new Error(this.editPwdErrors.adminLoginRepeatPwd))
      } else {
        callback()
      }
    }
    return {
      region_level: 0,
      parentregioninfolist: {},
      villageshow: false,
      options: [],
      tableHeight: 400,
      adminlist: [],
      lsp: [],
      permission: {
        isHaveAddPermission: false,
        isHaveEditPermission: false,
        isHaveChangeStatusPermission: false,
        isHaveInitializationPermission: false,
        isHaveRevokeAdminAuthPermission: false, //注销实名认证
        isHaveEditAdminLoginPwdPermission: false, //初始化密码
      },
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      showDataLoading: true,
      allList: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      countryList: [],
      villageList: [],
      isSys: false,
      //搜索
      searchForm: {
        cityLevellist: [],
        cityLeve: '',
        villageID: '',
        keywordname: '',
        value: '',
        keywords: '',
        isUseOptions: [
          {
            value: -1,
            label: '全部',
          },
          {
            value: 1,
            label: '可用',
          },
          {
            value: 0,
            label: '不可用',
          },
        ],
        isUseState: '',
        regionLevel: '',
        regionLevellist: [
          {
            value: 0,
            label: '系统',
          },
          {
            value: 1,
            label: '省级',
          },
          {
            value: 2,
            label: '市级',
          },
          {
            value: 3,
            label: '县级',
          },
          {
            value: 4,
            label: '乡级',
          },
        ],
      },
      //添加
      addKey: 1,
      dialogAddAdminFormVisible: false,
      addForm: {
        allregionLevel: [
          {
            value: 0,
            label: '系统',
          },
          {
            value: 1,
            label: '省级',
          },
          {
            value: 2,
            label: '市级',
          },
          {
            value: 3,
            label: '县级',
          },
          {
            value: 4,
            label: '乡级',
          },
          {
            value: 5,
            label: '村级',
          },
        ],
        regionLevel: 0,
        adminLoginName: '',
        adminunitname: '',
        adminLoginPwd: 'LD00-00',
        roleID: 1,
        rolelist: [],
        provinceID: 410000000000,
        cityID: '',
        districtID: '',
        countryID: '',
        villageID: '',
      },
      adminRegionLevel: false,
      addbuttonloading: false,
      addbuttondisabled: false,
      addRules: {
        adminLoginName: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { validator: validateCallAdminLoginName },
        ],
        adminunitname: [
          { required: true, message: '请输入行政单位', trigger: 'change' },
        ],
      },
      addErrors: {
        allregionLevel: [
          {
            value: 0,
            label: '系统',
          },
          {
            value: 1,
            label: '省级',
          },
          {
            value: 2,
            label: '市级',
          },
          {
            value: 3,
            label: '县级',
          },
          {
            value: 4,
            label: '乡级',
          },
          {
            value: 5,
            label: '村级',
          },
        ],
        regionLevel: 0,
        adminName: '',
        adminLoginName: '',
        adminLoginPwd: '',
        adminLoginRepeatPwd: '',
        adminEmail: '',
      },
      //修改
      editKey: 1,
      dialogEditAdminFormVisible: false,
      editForm: {
        adminID: 0,
        adminName: '',
        adminMobileTel: '',
        adminIdcardNumber: '',
        //    region_level:0,
        roleID: 1,
        rolelist: [],
        adminunitname: '',
      },
      sprovinceID: '',
      scityID: '',
      sdistrictID: '',
      scountryID: '',
      svillageID: '',
      editbuttonloading: false,
      editRules: {
        adminName: [
          { required: true, message: '请输入管理员名称', trigger: 'blur' },
          { validator: validateCallEditAdminName },
        ],
        adminunitname: [
          { required: true, message: '请输入行政单位', trigger: 'change' },
        ],
        adminMobileTel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatetel },
        ],
        adminIdcardNumber: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: validatecard },
        ],
      },
      editErrors: {
        adminName: '',
        adminLoginName: '',
        adminEmail: '',
        adminunitname: '',
      },
      //修改密码
      editPwdKey: 1,
      dialogEditAdminPwdFormVisible: false,
      editPwdForm: {
        adminID: 0,
        adminLoginPwd: '',
        adminLoginRepeatPwd: '',
      },
      editPwdButtonLoading: false,
      editPwdRules: {
        adminLoginPwd: [
          { validator: validateEditPwdPass, trigger: 'blur' },
          { validator: validateCallEditPwdLoginPassword },
        ],
        adminLoginRepeatPwd: [
          { validator: validateEditPwdRepeatPass, trigger: 'blur' },
          { validator: validateCallEditPwdLoginRepeatPassword },
        ],
        adminunitname: [
          { required: true, message: '请输入行政单位', trigger: 'change' },
        ],
      },
      editPwdErrors: {
        adminLoginPwd: '',
        adminLoginRepeatPwd: '',
      },
      adminRegionLevelnum: 0,
    }
  },
  created: async function () {
    console.log(store.getters.isSys)
    //    if(store.getters.isSys==1){
    //          this.isSys = true
    //     }else{
    //          this.isSys = false
    //     }
    this.adminRegionLevelnum = store.getters.adminRegionLevel
    if (store.getters.adminRegionLevel == 0) {
      this.villageshow = true
      await this.getparentregioninfo()
    } else if (
      store.getters.adminRegionLevel > 0 &&
      store.getters.adminRegionLevel < 5
    ) {
      let adminRegionLevelnum = Number(store.getters.adminRegionLevel) + 1
      this.getsearchRegionList(adminRegionLevelnum, store.getters.adminRegionID)
    } else {
      await this.getparentregioninfo()
      this.searchForm.value1 = store.getters.adminRegionID
    }
    if (store.getters.adminRegionLevel <= 1) {
      this.adminRegionLevel = true
    } else {
      this.adminRegionLevel = false
    }
    await this.getAdminList(1, 10, '', -1, -1, '')
    this.getRegionList(1, 0)
    this.getRegionList(2, 410000000000)

    // table的高
    this.tableHeight =
      $('.tab-content').height() -
      30 -
      $('.searchcontent').outerHeight(true) -
      $('.pageblock').outerHeight(true)
    //   $(".el-table ").css("min-height",$(".tab-content").height() -30 -$(".searchcontent").outerHeight(true) +"px");
    this.permission.isHaveAddPermission = permissionTool.isHavePermission(
      'newadminadd',
      this.lsp
    )
    this.permission.isHaveEditPermission = permissionTool.isHavePermission(
      'newadminedit',
      this.lsp
    )
    this.permission.isHaveChangeStatusPermission =
      permissionTool.isHavePermission('editadminusestatus', this.lsp)
    this.permission.isHaveInitializationPermission =
      permissionTool.isHavePermission('delregioninfo', this.lsp)
    //撤销实名认证
    this.permission.isHaveRevokeAdminAuthPermission =
      permissionTool.isHavePermission('revokeadminauth', this.lsp)
    //初始化密码
    this.permission.isHaveEditAdminLoginPwdPermission =
      permissionTool.isHavePermission('editadminloginpwd', this.lsp)
  },
    deactivated: function () {
    this.dialogAddAdminFormVisible = false;
    this.dialogEditAdminFormVisible = false;
    this.dialogEditAdminPwdFormVisible = false;
  },
  methods: {
    initLeft() {
      return sysframe.getSideBarLeft()
    },
    async getAdminList(
      page,
      page_size,
      key_words,
      is_use,
      filter_region_id,
      admin_unit_name
    ) {
      this.adminlist = []
      if (is_use === '') {
        is_use = -1
      }
      if (filter_region_id === '') {
        filter_region_id = -1
      }
      await adminModule
        .getAdminList(
          page,
          page_size,
          key_words,
          is_use,
          filter_region_id,
          admin_unit_name
        )
        .then((response) => {
          this.showDataLoading = false
          switch (response.data.code) {
            case 100:
              this.adminlist = response.data.result
              this.adminlist.forEach((e) => {
                e.closeTime = publicFun.timestampToTime(e.closeTime)
              })
              this.lsp = response.data.lsp
              this.totalCount = response.data.recordcount
              break
            case 101:
              this.adminlist = []
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            default:
              this.$message.error(response.data.message)
          }
        })
        .catch((error) => { })
    },
    //获取城市列表
    async getRegionList(region_level, p_region_id) {
      await regionModule
        .regioninfogetlist(region_level, p_region_id)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              if (region_level == 1) {
                this.provinceList = response.data.result
              } else if (region_level == 2) {
                this.cityList = response.data.result
                console.log(this.cityList)
              } else if (region_level == 3) {
                this.districtList = response.data.result
              } else if (region_level == 4) {
                this.countryList = response.data.result
              } else if (region_level == 5) {
                this.villageList = response.data.result
              }
              break
            // case 102:
            //     this.$message.error(response.data.message);
            // break;
            // default:
            //     this.$message.error(response.data.message);
            // break;
          }
        })
        .catch((error) => {
          console.log('error', error)
          this.loading = false
        })
    },
    clickFormchange(num2, parentID) {
      console.log('dshkladfhfdsajkfhl')
      switch (num2) {
        case 1:
          console.log(parentID, this.sprovinceID)
          if (parentID != 0) {
            console.log(parentID, 0)
            this.provinceList = []
            this.getRegionList(1, parentID)
          }

          break
        case 2:
          if (parentID != this.sprovinceID || this.cityList.length <= 1) {
            console.log(parentID, this.sprovinceID)
            this.cityList = []
            this.sprovinceID = this.addForm.provinceID
            this.getRegionList(2, parentID)
          }
          break
        case 3:
          if (parentID != this.scityID || this.districtList.length <= 1) {
            console.log(parentID, this.scityID)
            this.districtList = []
            this.scityID = this.addForm.cityID
            this.getRegionList(3, parentID)
          }
          break
        case 4:
          if (parentID != this.sdistrictID || this.countryList.length <= 1) {
            console.log(parentID, this.sdistrictID)
            this.countryList = []
            this.sdistrictID = this.addForm.districtID
            this.getRegionList(4, parentID)
          }
          break
        case 5:
          if (parentID != this.scountryID || this.villageList.length <= 1) {
            console.log(parentID, this.scountryID)
            this.countryList = []
            this.scountryID = this.addForm.countryID
            this.getRegionList(5, parentID)
          }
          break

        default:
          break
      }
    },
    //num1：1选择行政区划,2办公地址
    //num2：2市级,3省级
    //parentID,父级ID
    searchFormchange(num2, parentID) {
      console.log('dshkladfhfdsajkfhl')
      switch (num2) {
        case 2:
          console.log('11111')
          this.cityList = []
          this.addForm.cityID = ''
          this.districtList = []
          this.addForm.districtID = ''
          this.countryList = []
          this.addForm.countryID = ''
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(2, parentID)
          break
        case 3:
          console.log('11111')
          this.districtList = []
          this.addForm.districtID = ''
          this.countryList = []
          this.addForm.countryID = ''
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(3, parentID)
          break
        case 4:
          console.log('11111')
          this.countryList = []
          this.addForm.countryID = ''
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(4, parentID)
          break
        case 5:
          console.log('11111')
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(5, parentID)
          break

        default:
          break
      }
    },
    editFormchange(num2, parentID) {
      console.log('dshkladfhfdsajkfhl')
      switch (num2) {
        case 2:
          console.log('11111')
          this.cityList = []
          this.addForm.cityID = ''
          this.districtList = []
          this.addForm.districtID = ''
          this.countryList = []
          this.addForm.countryID = ''
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(2, parentID)
          break
        case 3:
          console.log('11111')
          this.districtList = []
          this.addForm.districtID = ''
          this.countryList = []
          this.addForm.countryID = ''
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(3, parentID)
          break
        case 4:
          console.log('11111')
          this.countryList = []
          this.addForm.countryID = ''
          this.villageList = []
          this.addForm.villageID = '' / this.getRegionList(4, parentID)
          break
        case 5:
          console.log('11111')
          this.villageList = []
          this.addForm.villageID = ''
          this.getRegionList(5, parentID)
          break

        default:
          break
      }
    },
    getRowKey(row) {
      return row.aid
    },
    //更改每页显示条数
    async handleSizeChange(val) {
      this.pageSize = val
      this.pageIndex = 1
      await this.getAdminList(
        this.pageIndex,
        this.pageSize,
        this.searchForm.keywords,
        this.searchForm.isUseState,
        this.searchForm.villageID,
        this.searchForm.keywordname
      )
    },
    //设置当前页
    async handleCurrentChange(val) {
      this.pageIndex = val
      await this.getAdminList(
        this.pageIndex,
        this.pageSize,
        this.searchForm.keywords,
        this.searchForm.isUseState,
        this.searchForm.villageID,
        this.searchForm.keywordname
      )
    },
    async onSearch() {
      if (store.getters.adminRegionLevel == 5) {
        this.searchForm.villageID = store.getters.adminRegionID
      } else if (store.getters.adminRegionLevel == 0) {
        let villageID = 0
        if (this.searchForm.value != '') {
          // if(this.searchForm.value.length<=3){
          //     this.$message.error("请选择县级以下的区划单位");
          //     return
          // }else{
          villageID = this.searchForm.value[this.searchForm.value.length - 1]
          // }
          console.log(this.searchForm.value, villageID)
        } else {
          villageID = 0
        }

        this.searchForm.villageID = villageID
      } else {
        this.searchForm.villageID = this.searchForm.cityLeve
      }
      this.totalCount = 0
      this.page = 1
      await this.getAdminList(
        this.pageIndex,
        this.pageSize,
        this.searchForm.keywords,
        this.searchForm.isUseState,
        this.searchForm.villageID,
        this.searchForm.keywordname
      )
    },
    clearEditList(addForm) {
      this.$refs[addForm].resetFields()
      console.log('sdhkas')
      this.districtList = []
      this.countryList = []
      this.villageList = []
      this.clear()
      this.$forceUpdate()
    },

    selectChange() {
      this.districtList = []
      this.countryList = []
      this.addForm.cityID = ''
      this.addForm.districtID = ''
      this.addForm.countryID = ''
    },
    clear() {
      this.addForm.adminLoginName = ''
      this.addForm.regionLevel = 0
      this.addForm.provinceID = 410000000000
      this.addForm.cityID = ''
      this.addForm.districtID = ''
      this.addForm.countryID = ''
      this.addForm.roleID = 1
      this.districtList = []
      this.countryList = []
      this.villageList = []
    },
    async onAdd() {
      this.countryList = []
      this.getRegionList(2, 410000000000)
      this.clear()
      this.addKey++
      this.addForm.rolelist = []
      await roleModule
        .getRoleList()
        .then((response) => {
          switch (response.data.code) {
            case 100:
              this.addForm.rolelist = response.data.result
              this.dialogAddAdminFormVisible = true
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              break
          }
        })
        .catch((error) => { })
    },
    async onAddSubmit() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          console.log(this.addForm.regionLevel)

          if (this.addForm.regionLevel == 1) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 2) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 3) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
            if (this.addForm.districtID == '') {
              this.$message.error('请选择县级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 4) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
            if (this.addForm.districtID == '') {
              this.$message.error('请选择县级行政区划')
              return
            }
            if (this.addForm.countryID == '') {
              this.$message.error('请选择乡级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 5) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
            if (this.addForm.districtID == '') {
              this.$message.error('请选择县级行政区划')
              return
            }
            if (this.addForm.countryID == '') {
              this.$message.error('请选择乡级行政区划')
              return
            }
            if (this.addForm.villageID == '') {
              this.$message.error('请选择村级行政区划')
              return
            }
          }
          let region_id
          if (this.addForm.regionLevel == 4) {
            region_id = this.addForm.countryID
          } else if (this.addForm.regionLevel == 3) {
            region_id = this.addForm.districtID
          } else if (this.addForm.regionLevel == 2) {
            region_id = this.addForm.cityID
          } else if (this.addForm.regionLevel == 1) {
            region_id = this.addForm.provinceID
          } else if (this.addForm.regionLevel == 5) {
            region_id = this.addForm.villageID
          } else {
            region_id = 0
          }

          //   login_name, region_level, region_id, role_id,
          await adminModule
            .addAdmin(
              this.addForm.adminLoginName,
              this.addForm.regionLevel,
              region_id,
              this.addForm.roleID,
              this.addForm.adminunitname
            )
            .then((resp) => {
              switch (resp.data.code) {
                case 100:
                  {
                    console.log('12121212121')
                    // var newAdmin = { aid:resp.data.result.adminID,aName:this.addForm.adminName,aLoginName:this.addForm.adminLoginName,isUse:this.addForm.isUse == true ? 1:0,email:this.addForm.adminEmail,roleName:this.addForm.rolelist.filter(item=>item.roleID == this.addForm.roleID )[0].roleName }
                    // this.adminlist.push(newAdmin)
                    this.dialogAddAdminFormVisible = false
                    this.addForm.adminLoginName = ''
                    this.clear()
                    this.addForm.roleID = 1
                    this.addForm.rolelist = []
                    this.getAdminList(
                      this.pageIndex,
                      this.pageSize,
                      this.searchForm.keywords,
                      this.searchForm.isUseState,
                      this.searchForm.villageID,
                      this.searchForm.keywordname
                    )
                    const h = this.$createElement
                    this.$notify({
                      title: '成功',
                      message: h('span', '添加成功'),
                      type: 'success',
                    })
                    // this.$message({message: '添加成功',type: 'success'});
                  }
                  break
                case 100002:
                  this.$message.error(baseconfig.no_permission_message)
                  break
                default:
                  this.$message.error(resp.data.message)
                  break
              }
            })
            .catch((error) => { })
        } else {
          return false
        }
      })
    },
    async onEditAdmin(row) {
      this.editKey++
      this.editForm.adminID = row.adminID
      this.editForm.rolelist = []
      await roleModule
        .getRoleList()
        .then((response) => {
          switch (response.data.code) {
            case 100:
              this.editForm.rolelist = response.data.result
              break
            default:
              break
          }
        })
        .catch((error) => { })

      await adminModule
        .getAdminInfo(row.adminID)
        .then((resp) => {
          switch (resp.data.code) {
            case 100:
              this.editForm.adminID = resp.data.result.adminID
              this.editForm.adminName = resp.data.result.adminName
              this.addForm.regionLevel = resp.data.result.adminRegionLevel
              this.editForm.adminRegionID = resp.data.result.adminRegionID
              this.editForm.adminRegionLevelName =
                resp.data.result.adminRegionLevelName
              this.editForm.adminIdcardNumber =
                resp.data.result.adminIdcardNumber
              this.editForm.adminMobileTel = resp.data.result.adminMobileTel
              this.editForm.adminunitname = resp.data.result.adminUnitName
              this.editForm.roleID = resp.data.result.roleID
              this.addForm.provinceID =
                resp.data.result.provinceID == 0
                  ? ''
                  : resp.data.result.provinceID
              this.addForm.cityID =
                resp.data.result.cityID == 0 ? '' : resp.data.result.cityID

              if (resp.data.result.cityID != 0) {
                // this.getRegionList(2,410000000000)
                this.cityList = [
                  {
                    baseRegionID: resp.data.result.cityID,
                    baseRegionName: resp.data.result.cityName,
                  },
                ]
              }
              this.addForm.countryID =
                resp.data.result.townID == 0 ? '' : resp.data.result.townID
              if (resp.data.result.townID != 0) {
                // this.getRegionList(3,resp.data.result.cityID)
                this.countryList = [
                  {
                    baseRegionID: resp.data.result.townID,
                    baseRegionName: resp.data.result.townName,
                  },
                ]
              }

              this.addForm.districtID =
                resp.data.result.countyID == 0 ? '' : resp.data.result.countyID
              if (resp.data.result.countyID != 0) {
                // this.getRegionList(4,resp.data.result.townID)
                this.districtList = [
                  {
                    baseRegionID: resp.data.result.countyID,
                    baseRegionName: resp.data.result.countyName,
                  },
                ]
              }
              this.addForm.villageID =
                resp.data.result.villageID == 0
                  ? ''
                  : resp.data.result.villageID
              if (resp.data.result.villageID != 0) {
                // this.getRegionList(5,resp.data.result.countyID)
                this.villageList = [
                  {
                    baseRegionID: resp.data.result.villageID,
                    baseRegionName: resp.data.result.villageName,
                  },
                ]
              }

              this.sprovinceID =
                resp.data.result.provinceID == 0
                  ? ''
                  : resp.data.result.provinceID
              this.scityID =
                resp.data.result.cityID == 0 ? '' : resp.data.result.cityID
              this.scountryID =
                resp.data.result.townID == 0 ? '' : resp.data.result.townID
              this.sdistrictID =
                resp.data.result.countyID == 0 ? '' : resp.data.result.countyID
              this.svillageID =
                resp.data.result.villageID == 0
                  ? ''
                  : resp.data.result.villageID
              console.log(this.addForm.districtID, this.sdistrictID)
              this.dialogEditAdminFormVisible = true
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(resp.data.message)
              break
            default:
              this.$message.error(resp.data.message)
              break
          }
        })
        .catch((error) => { })
    },
    onEditSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          if (this.addForm.regionLevel == 1) {
            if (this.editForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 2) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 3) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
            if (this.addForm.districtID == '') {
              this.$message.error('请选择县级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 4) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
            if (this.addForm.districtID == '') {
              this.$message.error('请选择县级行政区划')
              return
            }
            if (this.addForm.countryID == '') {
              this.$message.error('请选择乡级行政区划')
              return
            }
          }
          if (this.addForm.regionLevel == 5) {
            if (this.addForm.provinceID == '') {
              this.$message.error('请选择省级行政区划')
              return
            }
            if (this.addForm.cityID == '') {
              this.$message.error('请选择市级行政区划')
              return
            }
            if (this.addForm.districtID == '') {
              this.$message.error('请选择县级行政区划')
              return
            }
            if (this.addForm.countryID == '') {
              this.$message.error('请选择乡级行政区划')
              return
            }
            if (this.addForm.villageID == '') {
              this.$message.error('请选择村级行政区划')
              return
            }
          }
          let region_id
          if (this.addForm.regionLevel == 4) {
            region_id = this.addForm.countryID
          } else if (this.addForm.regionLevel == 3) {
            region_id = this.addForm.districtID
          } else if (this.addForm.regionLevel == 2) {
            region_id = this.addForm.cityID
          } else if (this.addForm.regionLevel == 1) {
            region_id = this.addForm.provinceID
          } else if (this.addForm.regionLevel == 5) {
            region_id = this.addForm.villageID
          } else {
            region_id = 0
          }

          await adminModule
            .editAdmin(
              this.editForm.adminID,
              this.editForm.adminName,
              this.editForm.adminMobileTel,
              this.editForm.adminIdcardNumber,
              this.addForm.regionLevel,
              region_id,
              this.editForm.roleID,
              this.editForm.adminunitname
            )
            .then((resp) => {
              switch (resp.data.code) {
                case 100:
                  {
                    // var editAdminIndex = this.adminlist.findIndex((item)=> item.aid === this.editForm.adminID)
                    // if(editAdminIndex != -1){
                    //     this.adminlist[editAdminIndex].aName=this.editForm.adminName
                    //     this.adminlist[editAdminIndex].aLoginName=this.editForm.adminLoginName
                    //     this.adminlist[editAdminIndex].isUse=this.editForm.isUse == true ? 1:0
                    //     this.adminlist[editAdminIndex].email=this.editForm.adminEmail
                    //     this.adminlist[editAdminIndex].roleName=this.editForm.rolelist.filter(item=>item.roleID == this.editForm.roleID )[0].roleName
                    // }
                    this.dialogEditAdminFormVisible = false
                    this.getAdminList(
                      this.pageIndex,
                      this.pageSize,
                      this.searchForm.keywords,
                      this.searchForm.isUseState,
                      this.searchForm.villageID,
                      this.searchForm.keywordname
                    )
                    this.editForm.adminName = ''
                    this.editForm.adminMobileTel = ''
                    this.editForm.adminIdcardNumber = ''
                    this.clear()

                    this.editForm.roleID = 1

                    const h = this.$createElement
                    this.$notify({
                      title: '成功',
                      message: h('span', '修改成功'),
                      type: 'success',
                    })
                    // this.$message({message: '修改成功',type: 'success'});
                  }
                  break
                case 101:
                  this.$message.error(resp.data.message)
                  break
                case 100002:
                  this.$message.error(baseconfig.no_permission_message)
                  break
                case 102:
                  this.$message.error(resp.data.message)
                  break
                default:
                  this.$message.error(resp.data.message)
                  break
              }
            })
            .catch((error) => { })
        } else {
          return false
        }
      })
    },
    //初始化密码
    async initializationAdmin(row) {
      await adminModule
        .initadminpwd(row.adminID)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                // var editIndex = this.adminlist.findIndex((item)=> item.aid === row.aid)
                // if(editIndex != -1){
                //     this.adminlist.splice(editIndex)
                // }
                const h = this.$createElement
                this.$notify({
                  title: '成功',
                  message: h('span', '初始化密码成功'),
                  type: 'success',
                })
                // this.$message({message: '删除成功',type: 'success'})
              }
              break
            case 101:
            case 103:
              this.$message.error(response.data.message)
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch(function (error) { })
    },
    // 注销/启用
    // // 注销
    async closeAdminStatus(row, k) {
      let isUse
      if (row.isUse == 0) {
        isUse = 1
      } else {
        isUse = 0
      }
      await adminModule
        .editadminusestatus(row.adminID)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              if (isUse == 1) {
                const h = this.$createElement
                this.$notify({
                  title: '成功',
                  message: h('span', '启用成功'),
                  type: 'success',
                })
              } else {
                const h = this.$createElement
                this.$notify({
                  title: '成功',
                  message: h('span', '注销成功'),
                  type: 'success',
                })
              }

              this.getAdminList(
                this.pageIndex,
                this.pageSize,
                this.searchForm.keywords,
                this.searchForm.isUseState,
                this.searchForm.villageID,
                this.searchForm.keywordname
              )

              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch(function (error) { })
    },
    onEditAdminPwd(row) {
      this.editPwdKey++
      this.editPwdForm.adminID = row.aid
      this.dialogEditAdminPwdFormVisible = true
    },
    async onEditPwdSubmit() {
      this.$refs.editPwdForm.validate(async (valid) => {
        if (valid) {
          this.editPwdButtonLoading = true
          await adminModule
            .editAdminPwd(
              this.editPwdForm.adminID,
              this.editPwdForm.adminLoginPwd,
              this.editPwdForm.adminLoginRepeatPwd
            )
            .then((resp) => {
              this.editPwdButtonLoading = false
              switch (resp.data.code) {
                case 100:
                  {
                    this.dialogEditAdminPwdFormVisible = false
                    this.editPwdForm.adminLoginPwd = ''
                    this.editPwdForm.adminLoginRepeatPwd = ''
                    const h = this.$createElement
                    this.$notify({
                      title: '成功',
                      message: h('span', '修改成功'),
                      type: 'success',
                    })
                    // this.$message({message: '修改成功',type: 'success'});
                  }
                  break
                case 101:
                  this.$message.error(resp.data.message)
                  break
                case 100002:
                  this.$message.error(baseconfig.no_permission_message)
                  break
                case 102:
                  this.$message.error(resp.data.message)
                  break
                default:
                  this.$message.error(resp.data.message)
                  break
              }
            })
            .catch((error) => { })
        } else {
          return false
        }
      })
    },
    async deleteAdmin(row) {
      await adminModule
        .deleteAdmin(row.aid)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                var editIndex = this.adminlist.findIndex(
                  (item) => item.aid === row.aid
                )
                if (editIndex != -1) {
                  this.adminlist.splice(editIndex)
                }
                const h = this.$createElement
                this.$notify({
                  title: '成功',
                  message: h('span', '删除成功'),
                  type: 'success',
                })
                // this.$message({message: '删除成功',type: 'success'})
              }
              break
            case 100002:
              this.$message.error(baseconfig.no_permission_message)
              break
            case 102:
              this.$message.error(response.data.message)
              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch(function (error) { })
    },
    //获取城市列表
    async getRegionLists(currentIds, p_region_id) {
      let currentIdsSize = currentIds.length
      let region_level = currentIdsSize + 1
      let this_is = this
      console.log(1111, currentIds)
      await regionModule
        .regioninfogetlist(region_level, p_region_id)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                if (region_level == 1) {
                  this_is.options = []
                  response.data.result.forEach(function (r, i) {
                    if (r.baseRegionID == 410000000000) {
                      this_is.options.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    }
                  })
                }
                if (region_level == 2) {
                  console.log('55555', this.parentregioninfolist.regionLevel)
                  let cities = new Array()
                  if (this.parentregioninfolist.regionLevel >= 2) {
                    cities.push({
                      value: this.parentregioninfolist.cityID,
                      label: this.parentregioninfolist.cityName,
                      children: [],
                    })
                  } else {
                    response.data.result.forEach(function (r, i) {
                      cities.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    })
                  }

                  this_is.options.forEach(function (r, index) {
                    if (r.value === currentIds[0]) {
                      this_is.options[index].children = cities
                    }
                  })
                }
                if (region_level == 3) {
                  let cities = new Array()
                  if (this.parentregioninfolist.regionLevel >= 3) {
                    cities.push({
                      value: this.parentregioninfolist.districtID,
                      label: this.parentregioninfolist.districtName,
                      children: [],
                    })
                  } else {
                    response.data.result.forEach(function (r, i) {
                      cities.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    })
                  }
                  this_is.options.forEach(function (r0, i0) {
                    if (r0.value === currentIds[0]) {
                      this_is.options[i0].children.forEach(function (r1, i1) {
                        if (r1.value === currentIds[1]) {
                          this_is.options[i0].children[i1].children = cities
                        }
                      })
                    }
                  })
                }
                if (region_level == 4) {
                  let cities = new Array()
                  if (this.parentregioninfolist.regionLevel >= 4) {
                    cities.push({
                      value: this.parentregioninfolist.townshipID,
                      label: this.parentregioninfolist.townshipName,
                      children: [],
                    })
                  } else {
                    response.data.result.forEach(function (r, i) {
                      cities.push({
                        value: r.baseRegionID,
                        label: r.baseRegionName,
                        children: [],
                      })
                    })
                  }
                  this_is.options.forEach(function (r0, i0) {
                    if (r0.value === currentIds[0]) {
                      this_is.options[i0].children.forEach(function (r1, i1) {
                        if (r1.value == currentIds[1]) {
                          console.log(i1, currentIds[1], r1.value)
                          // this_is.options[i0].children[i1].children = cities;
                          this_is.options[i0].children[i1].children.forEach(
                            function (r2, i2) {
                              if (r2.value === currentIds[2]) {
                                this_is.options[i0].children[i1].children[
                                  i2
                                ].children = cities
                              }
                            }
                          )
                        }
                      })
                    }
                  })
                }
                if (region_level == 5) {
                  let cities = new Array()
                  response.data.result.forEach(function (r, i) {
                    cities.push({
                      value: r.baseRegionID,
                      label: r.baseRegionName,
                    })
                  })
                  this_is.options.forEach(function (r0, i0) {
                    if (r0.value === currentIds[0]) {
                      this_is.options[i0].children.forEach(function (r1, i1) {
                        if (r1.value == currentIds[1]) {
                          console.log(i1, currentIds[1], r1.value)
                          // this_is.options[i0].children[i1].children = cities;
                          this_is.options[i0].children[i1].children.forEach(
                            function (r2, i2) {
                              if (r2.value === currentIds[2]) {
                                this_is.options[i0].children[i1].children[
                                  i2
                                ].children.forEach(function (r3, i3) {
                                  if (r3.value === currentIds[3]) {
                                    this_is.options[i0].children[i1].children[
                                      i2
                                    ].children[i3].children = cities
                                  }
                                })
                              }
                            }
                          )
                        }
                      })
                    }
                  })
                }
              }
              break
          }
        })
        .catch((error) => {
          console.log('error', error)
          this.loading = false
        })
    },
    handleItemChange(val) {
      this.values = val
      // console.log(val)
      let valSize = val.length
      let that = this
      console.log(121212121212121212121212, val, valSize)
      if (valSize == 1) {
        //   console.log(that.options)
        //第2级节点获取
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            that.getRegionLists(val, r.value)
            return
          }
        })
      }
      if (valSize == 2) {
        // console.log(that.options)
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            r.children.forEach(function (r0, i0) {
              if (r0.value === val[1]) {
                that.getRegionLists(val, r0.value)
                return
              }
            })
          }
        })
      }
      if (valSize == 3) {
        // console.log(that.options)
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            r.children.forEach(function (r0, i0) {
              if (r0.value === val[1]) {
                r0.children.forEach(function (r1, i1) {
                  if (r1.value === val[2]) {
                    that.getRegionLists(val, r1.value)
                    return
                  }
                })
              }
            })
          }
        })
      }
      if (valSize == 4) {
        // console.log(that.options)
        that.options.forEach(function (r, index) {
          if (r.value === val[0]) {
            r.children.forEach(function (r0, i0) {
              if (r0.value === val[1]) {
                r0.children.forEach(function (r1, i1) {
                  if (r1.value === val[2]) {
                    r1.children.forEach(function (r2, i2) {
                      if (r2.value === val[3]) {
                        that.getRegionLists(val, r2.value)
                        return
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }
    },
    handleCateChange() {
      // let this_is = this;
      // if(this.searchForm.value.length==0){
      //     let arr=[]
      //     this_is.options=arr
      //     console.log(this_is.options)
      //     this.getRegionList([],0)
      // }
      console.log(99999, this.searchForm.value, this.searchForm.value.length)
    },
    // 获取当前区划所有父级信息详情 HYT
    async getparentregioninfo() {
      await parentregioninfoModule
        .parentregioninfo()
        .then((response) => {
          switch (response.data.code) {
            case 100:
              {
                console.log('5555', response.data.result)
                this.searchForm.value1 = response.data.result.villageName
                this.parentregioninfolist = response.data.result
                console.log(Number(this.parentregioninfolist.regionLevel) - 1)
                this.getRegionLists([], 0)
              }
              break
            case 101:
              {
                this.getRegionLists([], 0)
              }

              break
            default:
              this.$message.error(response.data.message)
              break
          }
        })
        .catch((error) => {
          console.log('error', error)
        })
    },
    async getsearchRegionList(region_level, p_region_id) {
      console.log('调用城市', region_level, p_region_id)
      await regionModule
        .regioninfogetlist(region_level, p_region_id)
        .then((response) => {
          switch (response.data.code) {
            case 100:
              this.searchForm.cityLevellist = response.data.result
              console.log(4444, this.searchForm.cityLevellist)
              break
            // case 102:
            //     this.$message.error(response.data.message);
            // break;
            // default:
            //     this.$message.error(response.data.message);
            // break;
          }
        })
        .catch((error) => {
          console.log('error', error)
          this.loading = false
        })
    },

    async revokeAdminAuthHandle(row) {
      try {
        await adminModule
          .revokeadminauth(row.adminID)
          .then((response) => {
            switch (response.data.code) {
              case 100:
                this.$message({
                  message: response.data.message,
                  type: 'success',
                })
                this.getAdminList(
                  this.pageIndex,
                  this.pageSize,
                  this.searchForm.keywords,
                  this.searchForm.isUseState,
                  this.searchForm.villageID,
                  this.searchForm.keywordname
                )
                break
              case 102:
                this.$message.error(baseconfig.para_error_message)
                break
              case 100002:
                this.$message.error(baseconfig.no_permission_message)
                break
              default:
                this.$message.error(response.data.message)
                break
            }
          })
          .catch((error) => { })
      } catch (error) {
        //
      }
    },
  },
}
</script>
<style scoped>
.pageblock {
  text-align: right;
  margin-top: 5px;
}
</style>